import { findAndDelete, findAndReplace } from '@/utils';

import { MutationsCreator } from '@/store/utils';
import { showErrorToast } from '~/utils/toast-notifications';

export default {
  ADD_PORTFOLIO_ITEM_INIT: (state) => {
    state.addPortfolioItem = {
      loading: true,
      error: null,
      success: false,
    };
  },
  ADD_PORTFOLIO_ITEM_SUCCESS: (state) => {
    state.addPortfolioItem = {
      loading: false,
      error: null,
      success: true,
    };
  },
  ADD_PORTFOLIO_ITEM_ERROR: (state, error) => {
    state.addPortfolioItem = {
      loading: false,
      error: error,
      success: false,
    };
  },
  GET_TICKER_STOCK_VALUE_INIT: (state) => {
    state.getTickerStockValue.data = null;
    state.getTickerStockValue.error = null;
    state.getTickerStockValue.loading = true;
  },
  GET_TICKER_STOCK_VALUE_SUCCESS: (state, data) => {
    state.getTickerStockValue.data = data;
    state.getTickerStockValue.loading = false;
  },
  GET_TICKER_STOCK_VALUE_INIT_ERROR: (state, error) => {
    state.getTickerStockValue.error = error;
    state.getTickerStockValue.loading = false;
  },
  GET_SIMILAR_TICKERS_INIT: (state) => {
    state.getSimilarTickers.data = [];
    state.getSimilarTickers.error = null;
    state.getSimilarTickers.loading = true;
  },
  GET_SIMILAR_TICKERS_SUCCESS: (state, data) => {
    state.getSimilarTickers.data = data;
    state.getSimilarTickers.loading = false;
  },
  GET_SIMILAR_TICKERS_INIT_ERROR: (state, error) => {
    state.getSimilarTickers.error = error;
    state.getSimilarTickers.loading = false;
  },
  SET_GET_TICKER_VALUE_LOADING: (state, loading) => {
    state.getTickerStockRangeValue.loading = loading;
  },
  /**
   * This is currently required in order not to break the stock charts, but it should be refactored out.
   * @deprecated We should avoid using this since it prevents implementing more complex behaviors - e.g. SKD-1533
   */
  GET_TICKER_VALUE_INIT: (state) => {
    state.getTickerStockRangeValue.data = null;
    state.getTickerStockRangeValue.error = null;
    state.getTickerStockRangeValue.loading = true;
  },
  SET_GET_TICKER_VALUE_WITH_PERFORMANCE_LOADING: (state, loading) => {
    state.getTickerStockRangeWithOverall.loading = loading;
  },
  /**
   * This is currently required in order not to break the stock charts, but it should be refactored out.
   * @deprecated We should avoid using this since it prevents implementing more complex behaviors - e.g. SKD-1533
   */
  GET_TICKER_VALUE_WITH_PERFORMANCE_INIT: (state) => {
    state.getTickerStockRangeWithOverall.data = null;
    state.getTickerStockRangeWithOverall.error = null;
    state.getTickerStockRangeWithOverall.loading = true;
  },
  GET_TICKER_VALUE_SUCCESS: (state, data) => {
    state.getTickerStockRangeValue.data = data;
    state.getTickerStockRangeValue.loading = false;
  },
  GET_TICKER_VALUE_WITH_PERFORMANCE_SUCCESS: (state, data) => {
    state.getTickerStockRangeWithOverall.data = data;
    state.getTickerStockRangeWithOverall.loading = false;
  },
  GET_TICKER_VALUE_INIT_ERROR: (state, error) => {
    state.getTickerStockRangeValue.error = error;
    state.getTickerStockRangeValue.loading = false;
  },
  GET_TICKER_VALUE_WITH_PERFORMANCE_ERROR: (state, error) => {
    state.getTickerStockRangeWithOverall.error = error;
    state.getTickerStockRangeWithOverall.loading = false;
  },
  GET_MULTIPLE_TICKER_VALUE_SUCCESS: (state, data) => {
    state.getMultipleTickerStockRangeValue.data = data;
    state.getMultipleTickerStockRangeValue.loading = false;
  },
  GET_MULTIPLE_TICKER_VALUE_INIT_ERROR: (state, error) => {
    state.getMultipleTickerStockRangeValue.error = error;
    state.getMultipleTickerStockRangeValue.loading = false;
  },
  GET_MULTIPLE_TICKER_VALUE_WITH_PERFORMANCE_SUCCESS: (state, data) => {
    state.getMultipleTickerStockRangeValueWithOverall.data = data;
    state.getMultipleTickerStockRangeValueWithOverall.loading = false;
  },
  GET_MULTIPLE_TICKER_VALUE_WITH_PERFORMANCE_ERROR: (state, error) => {
    state.getMultipleTickerStockRangeValueWithOverall.error = error;
    state.getMultipleTickerStockRangeValueWithOverall.loading = false;
  },
  GET_TEAM_PORTFOLIO_PROFILES_INIT: (state) => {
    state.getTeamPortfolioProfilesValue.data = null;
    state.getTeamPortfolioProfilesValue.error = null;
    state.getTeamPortfolioProfilesValue.loading = true;
  },
  GET_TEAM_PORTFOLIO_PROFILES_SUCCESS: (state, data) => {
    state.getTeamPortfolioProfilesValue.data = data;
    state.getTeamPortfolioProfilesValue.loading = false;
  },
  GET_TEAM_PORTFOLIO_PROFILES_INIT_ERROR: (state, error) => {
    state.getTeamPortfolioProfilesValue.error = error;
    state.getTeamPortfolioProfilesValue.loading = false;
  },
  UPDATE_TEAM_PORTFOLIO_PROFILE_INIT: (state) => {
    state.updateTeamPortfolioProfileValue.data = null;
    state.updateTeamPortfolioProfileValue.error = null;
    state.updateTeamPortfolioProfileValue.loading = true;
  },
  UPDATE_TEAM_PORTFOLIO_PROFILE_SUCCESS: (state, data) => {
    const profileToUpdate = state.getTeamPortfolioProfilesValue.data.findIndex(
      (item) =>
        item.profileId === data.profileId &&
        item.portfolioId === data.portfolioId
    );
    state.getTeamPortfolioProfilesValue.data[
      profileToUpdate
    ].portfolioUserRole = data.portfolioUserRole;
  },
  UPDATE_TEAM_PORTFOLIO_PROFILE_ERROR: (state, error) => {
    state.updateTeamPortfolioProfileValue.error = error;
    state.updateTeamPortfolioProfileValue.loading = false;
  },
  DELETE_TEAM_PORTFOLIO_PROFILE_INIT: (state) => {
    state.deleteTeamPortfolioProfileValue.data = null;
    state.deleteTeamPortfolioProfileValue.error = null;
    state.deleteTeamPortfolioProfileValue.loading = true;
  },
  DELETE_TEAM_PORTFOLIO_PROFILE_SUCCESS: (state, data) => {
    const profileToRemove = state.getTeamPortfolioProfilesValue.data.findIndex(
      (item) =>
        item.profileId === data.profileId &&
        item.portfolioId === data.portfolioId
    );
    state.getTeamPortfolioProfilesValue.data.splice(profileToRemove, 1);
  },
  DELETE_TEAM_PORTFOLIO_PROFILE_ERROR: (state, error) => {
    state.deleteTeamPortfolioProfileValue.error = error;
    state.deleteTeamPortfolioProfileValue.loading = false;
  },
  CREATE_TEAM_PORTFOLIO_PROFILE_INIT: (state) => {
    state.createTeamPortfolioProfileValue.data = null;
    state.createTeamPortfolioProfileValue.error = null;
    state.createTeamPortfolioProfileValue.loading = true;
  },
  CREATE_TEAM_PORTFOLIO_PROFILE_SUCCESS: (state, data) => {
    data.forEach((portfolioMember) => {
      state.getTeamPortfolioProfilesValue.data.push(portfolioMember);
    });
  },
  CREATE_TEAM_PORTFOLIO_PROFILE_ERROR: (state, error) => {
    state.createTeamPortfolioProfileValue.error = error;
    state.createTeamPortfolioProfileValue.loading = false;
  },
  PORTFOLIO_SETTINGS_INIT: (state) => {
    state.updatePortfolio = { data: null, loading: null, error: null };
    state.deletePortfolio = { data: null, loading: null, error: null };
  },
  UPDATE_PORTFOLIO_INIT: (state) => {
    state.updatePortfolio = { data: null, loading: true, error: null };
  },
  UPDATE_PORTFOLIO_SUCCESS: (state, data) => {
    state.updatePortfolio.data = data;

    // TODO from Nikola: remove this when the privacy conditions are passed correctly
    // We keep the conditions we already have if none are provided.
    if (
      !state.getMyPortfolios.data?.portfolios ||
      !Array.isArray(state.getMyPortfolios.data.portfolios)
    ) {
      console.debug(
        'getMyPortfolios.data.portfolios is not defined, cannot update portfolio privacy conditions'
      );
      return;
    }

    const existingPortfolio = state.getMyPortfolios.data.portfolios.find(
      (p) => p.id === data.id
    );
    const updatedPortfolio = data.privacyConditions
      ? data
      : { ...data, privacyConditions: existingPortfolio?.privacyConditions };

    state.getMyPortfolios.data.portfolios = findAndReplace(
      state.getMyPortfolios.data.portfolios,
      'id',
      data.id,
      updatedPortfolio
    );

    state.updatePortfolio.loading = false;
  },
  UPDATE_PORTFOLIO_PRIVACY: (state, payload) => {
    if (
      !state.getPortfolioById ||
      !state.getPortfolioById.data ||
      state.getPortfolioById.data.portfolioId != payload.portfolioId
    ) {
      return;
    } else {
      state.getPortfolioById.data.isPublic = payload.isPublic;
      state.getPortfolioById.data.isListed = payload.isListed;
      state.getPortfolioById.data.canGetListed = payload.canGetListed;
      state.getPortfolioById.data.goListedDate = payload.goListedDate;
      // TODO from Nikola: remove this when the privacy conditions are passed correctly
      // We keep the conditions we already have if none are provided.
      if (payload.privacyConditions) {
        state.getPortfolioById.data.privacyConditions =
          payload.privacyConditions;
      }
      state.getPortfolioById.data.socials.totalRankings =
        payload.socials.totalRankings;
      state.getPortfolioById.data.leagueId = payload.leagueId;
      state.getPortfolioById.data.socials.rankInLeague =
        payload.socials.rankInLeague;
    }
  },
  UPDATE_PORTFOLIO_PERFORMANCE_INTERVALS: (state, data) => {
    if (
      !state.getPortfolioById ||
      !state.getPortfolioById.data ||
      state.getPortfolioById.data.portfolioId != data.portfolioId
    ) {
      return;
    } else {
      state.getPortfolioById.data.intervalPerformance =
        data.intervalPerformance;
    }
  },
  UPDATE_PORTFOLIO_PERFORMANCE_LEAGUE: (state, data) => {
    if (
      !state.getPortfolioById ||
      !state.getPortfolioById.data ||
      state.getPortfolioById.data.portfolioId != data.portfolioId
    ) {
      return;
    } else {
      state.getPortfolioById.data.league = data.league;
    }
  },
  UPDATE_PORTFOLIO_ERROR: (state, error) => {
    state.updatePortfolio.error = error;
    state.updatePortfolio.loading = false;
  },
  DELETE_PORTFOLIO_INIT: (state) => {
    state.deletePortfolio = { data: null, loading: null, error: null };
  },
  DELETE_PORTFOLIO_SUCCESS: (state, data) => {
    state.deletePortfolio.data = data;
    state.getMyPortfolios.data.portfolios = findAndDelete(
      state.getMyPortfolios.data.portfolios,
      'id',
      data
    );
  },
  DELETE_PORTFOLIO_ERROR: (state, error) => {
    state.deletePortfolio.error = error;
  },
  LIKE_PORTFOLIO_SUCCESS: (state, data) => {
    state.getPortfolioById.data.socials.isLiked = data.isLiked;
    state.getPortfolioById.data.socials.likeCount = data.likeCount;
  },
  LIKE_PORTFOLIO_ERROR: (state, error) => {
    state.deletePortfolio.error = error;
  },
  // Favorite portfolio
  GET_MY_FAVORITE_PORTFOLIOS_INIT: (state) => {
    state.myFavoritePortfolios = { loading: true, data: null, error: null };
  },
  SET_MY_FAVORITE_PORTFOLIOS_LOADING: (state, loading) => {
    state.myFavoritePortfolios.loading = loading;
  },
  GET_MY_FAVORITE_PORTFOLIOS_SUCCESS: (state, data) => {
    state.myFavoritePortfolios.data = data.favoritePortfolios;
    state.myFavoritePortfolios.loading = false;
  },
  GET_MY_FAVORITE_PORTFOLIOS_LOADING: (state, isLoading) => {
    state.myFavoritePortfolios.loading = isLoading;
  },
  GET_FAVORITE_PORTFOLIO_INIT: (state) => {
    state.isFavoritePortfolio = false;
  },
  GET_FAVORITE_PORTFOLIO_SUCCESS: (state, data) => {
    state.isFavoritePortfolio = data.isFavorited;
  },

  FAVORITE_PORTFOLIO_INIT: (state) => {
    state.isFavoritePortfolio = false;
  },
  FAVORITE_PORTFOLIO_SUCCESS: (state, data) => {
    if (state.getPortfolioById.data && state.getPortfolioById.data.socials) {
      state.getPortfolioById.data.socials.favoriteCount =
        data.data.favoriteCount;
      state.isFavoritePortfolio = data.data.isFavorited;
      state.getPortfolioById.data.socials.isFavorited = data.data.isFavorited;
    }

    if (state.myFavoritePortfolios && state.myFavoritePortfolios.length > 0) {
      state.myFavoritePortfolios = findAndDelete(
        state.myFavoritePortfolios,
        'id',
        data.id
      );
    }
  },

  // Top Gainer Portfolios
  GET_PORTFOLIOS_TOP_GAINERS_INIT: (state) => {
    state.portfolioTopGainers = { data: null, loading: true, error: null };
  },
  SET_PORTFOLIOS_TOP_GAINERS_LOADING: (state, loading) => {
    state.portfolioTopGainers.loading = loading;
  },
  GET_PORTFOLIOS_TOP_GAINERS_SUCCESS: (state, data) => {
    state.portfolioTopGainers.data = data;
    state.portfolioTopGainers.loading = false;
  },
  GET_PORTFOLIOS_TOP_GAINERS_ERROR: (state, er) => {
    state.portfolioTopGainers.data = er;
    state.portfolioTopGainers.loading = false;
  },
  LIKE_PORTFOLIO_TOP_GAINER_SUCCESS: (state, payload) => {
    const index = state.portfolioTopGainers.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.portfolioTopGainers.data[index].socials.isLiked =
        payload.socials.isLiked;
      state.portfolioTopGainers.data[index].socials.likeCount =
        payload.socials.likeCount;
    }
  },
  FAVORITE_PORTFOLIO_TOP_GAINER_SUCCESS: (state, payload) => {
    const index = state.portfolioTopGainers.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.portfolioTopGainers.data[index].socials.isFavorited =
        payload.socials.isFavorited;
      state.portfolioTopGainers.data[index].socials.favoriteCount =
        payload.socials.favoriteCount;
    }
  },

  // Main League
  GET_MAIN_LEAGUE_PORTFOLIO_TOP_GAINERS_INIT: (state) => {
    state.mainLeaguePortfolioTopGainers = {
      data: null,
      loading: true,
      error: null,
    };
  },
  SET_MAIN_LEAGUE_PORTFOLIO_TOP_GAINERS_LOADING: (state, loading) => {
    state.mainLeaguePortfolioTopGainers.loading = loading;
  },
  GET_MAIN_LEAGUE_PORTFOLIO_TOP_GAINERS_SUCCESS: (state, data) => {
    state.mainLeaguePortfolioTopGainers = {
      ...state.mainLeaguePortfolioTopGainers,
      data: data,
      loading: false,
    };
  },
  GET_MAIN_LEAGUE_PORTFOLIO_TOP_GAINERS_ERROR: (state, error) => {
    state.mainLeaguePortfolioTopGainers.error = error;
    state.mainLeaguePortfolioTopGainers.loading = false;
  },
  LIKE_PORTFOLIO_MAIN_LEAGUE_TOP_GAINER_SUCCESS: (state, payload) => {
    const index = state.mainLeaguePortfolioTopGainers.data.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.mainLeaguePortfolioTopGainers.data.data[index].socials.isLiked =
        payload.socials.isLiked;
      state.mainLeaguePortfolioTopGainers.data.data[index].socials.likeCount =
        payload.socials.likeCount;
    }
  },
  FAVORITE_PORTFOLIO_MAIN_LEAGUE_TOP_GAINER_SUCCESS: (state, payload) => {
    const index = state.mainLeaguePortfolioTopGainers.data.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.mainLeaguePortfolioTopGainers.data.data[index].socials.isFavorited =
        payload.socials.isFavorited;
      state.mainLeaguePortfolioTopGainers.data.data[
        index
      ].socials.favoriteCount = payload.socials.favoriteCount;
    }
  },

  // Profile Portfolios
  GET_PROFILE_PORTFOLIOS_INIT: (state) => {
    state.profilePortfolios = { data: null, loading: true, error: null };
  },
  GET_PROFILE_PORTFOLIOS_SUCCESS: (state, data) => {
    state.profilePortfolios.data = data;
    state.profilePortfolios.loading = false;
  },
  GET_PROFILE_PORTFOLIOS_ERROR: (state, er) => {
    state.profilePortfolios.data = er;
    state.profilePortfolios.loading = false;
  },
  LIKE_PROFILE_PORTFOLIO_SUCCESS: (state, payload) => {
    const index = state.profilePortfolios.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.profilePortfolios.data[index].socials.isLiked =
        payload.socials.isLiked;
      state.profilePortfolios.data[index].socials.likeCount =
        payload.socials.likeCount;
    }
  },
  LIKE_MY_PORTFOLIO_SUCCESS: (state, payload) => {
    const index = state.getMyPortfolios.data.portfolios.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.getMyPortfolios.data.portfolios[index].socials.isLiked =
        payload.socials.isLiked;
      state.getMyPortfolios.data.portfolios[index].socials.likeCount =
        payload.socials.likeCount;
    }
  },

  FAVORITE_PROFILE_PORTFOLIO_SUCCESS: (state, payload) => {
    const index = state.profilePortfolios.data.findIndex(
      (e) => e.id == payload.id
    );
    if (index !== -1) {
      state.profilePortfolios.data[index].socials.isFavorited =
        payload.socials.isFavorited;
      state.profilePortfolios.data[index].socials.favoriteCount =
        payload.socials.favoriteCount;
    }
  },

  UNFAVORITE_FAVORITE_PORTFOLIO_SUCCESS: (state, payload) => {
    const { id: portfolioId } = payload;

    const index = state.myFavoritePortfolios.data.findIndex(
      (p) => p.id === portfolioId
    );

    if (index !== -1) {
      state.myFavoritePortfolios.data.splice(index, 1);
    }
  },

  /// Portfolio Comments

  UPDATE_REPLY: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];

        // Reply-related info are not sent back from the API
        const replies = res[index].replies;
        const showLoadMore = res[index].showLoadMore;

        res[index] = payload;
        res[index].replies = replies;
        res[index].showLoadMore = showLoadMore;
        state.replies = res;
      }
    }
  },
  UPDATE_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.replies) return;

    const replyToUpdate = state.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    const newLikedState = !payload.isLiked;

    replyToUpdate.isLiked = newLikedState;

    replyToUpdate.likeCount = newLikedState
      ? (replyToUpdate.likeCount += 1)
      : (replyToUpdate.likeCount -= 1);
  },
  ROLLBACK_REPLY_LIKE: (state, payload) => {
    if (!state.replies) return;

    const replyToUpdate = state.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    replyToUpdate.isLiked = payload.isLiked;
    replyToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_NESTED_REPLY: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      const nestedIndex = state.replies[replyIndex].replies.findIndex(
        (p) => p.postId === payload.nestedReply.postId
      );

      if (replyIndex !== -1 && nestedIndex !== -1) {
        const replies = [...state.replies];
        const nestedReplies = [...replies[replyIndex].replies];

        nestedReplies[nestedIndex] = payload.nestedReply;
        replies[replyIndex].replies = nestedReplies;

        state.replies = replies;
      }
    }
  },
  UPDATE_NESTED_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.replies) return;

    const reply = state.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    const newLikedState = !payload.isLiked;

    nestedReplyToUpdate.isLiked = newLikedState;

    nestedReplyToUpdate.likeCount = newLikedState
      ? (nestedReplyToUpdate.likeCount += 1)
      : (nestedReplyToUpdate.likeCount -= 1);
  },
  ROLLBACK_NESTED_REPLY_LIKE: (state, payload) => {
    if (!state.replies) return;

    const reply = state.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    nestedReplyToUpdate.isLiked = payload.isLiked;
    nestedReplyToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_REPLY_AFTER_EDIT: (state, payload) => {
    const replyIndex = state.replies.findIndex(
      (i) => i.postId === payload.data.postId
    );
    if (replyIndex !== -1) {
      const reply = state.replies[replyIndex];
      if (reply.replies) payload.data.replies = reply.replies;
      if (reply.replyCount) payload.data.replyCount = reply.replyCount;
      state.replies.splice(replyIndex, 1, payload.data);
    } else {
      const nestedReplyIndex = state.replies.findIndex((reply) =>
        reply.replies.some((reply) => reply.postId === payload.data.postId)
      );
      if (nestedReplyIndex !== -1) {
        const replyIndex = state.replies.findIndex(
          (r) => r.postId == payload.data.target
        );
        if (replyIndex !== -1) {
          const reply = state.replies.find(
            (r) => r.postId == payload.data.target
          );

          reply.replies.splice(nestedReplyIndex, 1, payload.data);
          state.replies.splice(replyIndex, 1, reply);
        }
      }
    }
  },
  UPDATE_NESTED_REPLY_AFTER_EDIT: (state, payload) => {
    const reply = state.replies.find((e) => e.postId === payload.replyId);
    const replyIndex = state.replies.findIndex(
      (e) => e.postId === payload.replyId
    );
    if (replyIndex !== -1) {
      const nestedReplyIndex = reply.replies.findIndex(
        (e) => e.postId === payload.nestedReplyId
      );
      if (nestedReplyIndex !== -1) {
        const nestedReply = state.replies[replyIndex].replies[nestedReplyIndex];
        if (nestedReply) payload.data.replyCount = nestedReply.replyCount;
        if (nestedReply.replies) payload.data.replies = nestedReply.replies;
        state.replies[replyIndex].replies.splice(
          nestedReplyIndex,
          1,
          payload.data
        );
      }
    }
  },
  SET_REPLIES: (state, payload) => {
    state.replies = payload;
  },
  SET_NESTED_REPLIES: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);
      if (index !== -1) {
        const res = [...state.replies];
        res[index].replies = payload.replies;
        state.replies = res;
      }
    }
  },
  APPEND_REPLIES: (state, payload) => {
    state.replies = [...state.replies, ...payload];
  },
  APPEND_NEW_REPLY: (state, payload) => {
    if (state.postLimit) {
      if (!state.replies) {
        state.replies = [];
      }
      const newArray = state.replies.slice(0, 1);
      state.replies = [payload, ...newArray];
    } else {
      state.replies = [payload, ...state.replies];
    }
  },
  APPEND_NESTED_REPLIES: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];

        res[index].replies = [...res[index].replies, ...payload.replies];
        state.replies = res;
      }
    }
  },
  APPEND_NEW_NESTED_REPLY: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];
        if (!res[index].replies) res[index].replies = [];

        res[index].replies = [...res[index].replies, payload.post];
        state.replies = res;
      }
    }
  },
  SET_NESTED_REPLY_VIEW_MORE: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);
      if (index !== -1) {
        const res = [...state.replies];
        res[index].showLoadMore = payload.show;
        state.replies = res;
      }
    }
  },

  SET_REPLIES_LOADING: (state, isLoading) => {
    state.repliesLoading = isLoading;
  },
  SET_NEXT_REPLIES_LOADING: (state, isLoading) => {
    state.nextRepliesLoading = isLoading;
  },
  SET_NESTED_REPLIES_LOADING: (state, isLoading) => {
    state.nextRepliesLoading = isLoading;
  },

  SET_REPLIES_ERROR: (state, error) => {
    state.repliesError = error;
    showErrorToast(window.$nuxt.$t('error_post_page_replies'));
  },

  INIT_PAGE: (state) => {
    state.post = null;
    state.postLoading = false;
    state.postError = null;
    state.replies = null;
    state.repliesLoading = false;
    state.repliesError = null;
    state.newReplyCount = 0;
    state.isLoadFinished = false;
    state.postLimit = null;
  },

  INIT_REPLIES: (state) => {
    state.replies = null;
    state.repliesLoading = false;
    state.repliesError = null;
  },

  INCREMENT_REPLY_REPLYCOUNT: (state, postId) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === postId);

      if (index != -1) {
        state.replies[index].replyCount++;
      }
    }
  },
  INCREMENT_NESTED_REPLY_REPLYCOUNT: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      if (replyIndex > -1 && state.replies[replyIndex].replies) {
        const nestedIndex = state.replies[replyIndex].replies.findIndex(
          (p) => p.postId === payload.nestedReplyId
        );

        if (nestedIndex !== -1) {
          const replies = [...state.replies];
          const nestedReplies = [...replies[replyIndex].replies];

          nestedReplies[nestedIndex].replyCount++;
          replies[replyIndex].replies = nestedReplies;

          state.replies = replies;
        }
      }
    }
  },
  INCREMENT_REPLY_REPOSTCOUNT: (state, postId) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === postId);

      if (index != -1) {
        state.replies[index].repostCount++;
      }
    }
  },
  INCREMENT_NESTED_REPLY_REPOSTCOUNT: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      if (replyIndex > -1 && state.replies[replyIndex].replies) {
        const nestedIndex = state.replies[replyIndex].replies.findIndex(
          (p) => p.postId === payload.nestedReplyId
        );

        if (nestedIndex !== -1) {
          const replies = [...state.replies];
          const nestedReplies = [...replies[replyIndex].replies];

          nestedReplies[nestedIndex].repostCount++;
          replies[replyIndex].replies = nestedReplies;

          state.replies = replies;
        }
      }
    }
  },
  SET_IS_LOAD_FINISHED: (state, value) => {
    state.isLoadFinished = value;
  },
  INCREMENT_COMMENT_COUNT: (state) => {
    state.getPortfolioById.data.socials.commentCount++;
  },
  DELETE_PORTFOLIO_COMMENT_SUCCESS: (state, postId) => {
    if (state.replies) {
      const commentIndex = state.replies.findIndex((r) => r.postId === postId);

      if (commentIndex !== -1) {
        state.replies.splice(commentIndex, 1);
      }
    }
  },
  DELETE_NESTED_PORTFOLIO_COMMENT_SUCCESS: (state, payload) => {
    if (state.replies) {
      const postIndex = state.replies.findIndex(
        (r) => r.postId === payload.postId
      );

      if (postIndex !== -1) {
        const nestedReplyIndex = state.replies[postIndex].replies.findIndex(
          (nr) => nr.postId === payload.nestedReplyId
        );

        if (nestedReplyIndex !== -1) {
          // Decrementing reply count for the post
          state.replies[postIndex].replyCount--;
          state.replies[postIndex].replies.splice(nestedReplyIndex, 1);
        }
      }
    }
  },
  DELETE_NESTED_PORTFOLIO_COMMENT_ERROR: (state, error) => {
    state.deletePortfolioComment.error = error;
  },
  // Portfolio Search
  PORTFOLIO_SEARCH_INIT: (state) => {
    state.portfolioSearch.data = [];
    state.portfolioSearch.error = null;
    state.portfolioSearch.loading = true;
  },
  PORTFOLIO_SEARCH_SUCCESS: (state, data) => {
    state.portfolioSearch.data = data;
    state.portfolioSearch.loading = false;
  },
  PORTFOLIO_SEARCH_ERROR: (state, error) => {
    state.portfolioSearch.error = error;
    state.portfolioSearch.loading = false;
  },
  // Portfolio comparison tool
  PORTFOLIO_TO_COMPARE_INIT: (state) => {
    state.portfoliosToCompare.data = [];
  },
  ADD_PORTFOLIOS_TO_COMPARE: (state, data) => {
    if (state.portfoliosToCompare.data === null) {
      state.portfoliosToCompare.data = [];
    }
    data.forEach((portfolio) => {
      state.portfoliosToCompare.data.push(portfolio);
    });
  },
  REMOVE_PORTFOLIO_TO_COMPARE: (state, portfolioId) => {
    const portfolioIndex = state.portfoliosToCompare.data.findIndex(
      (portfolio) => portfolio.id === portfolioId
    );
    if (portfolioIndex !== -1) {
      state.portfoliosToCompare.data.splice(portfolioIndex, 1);
    }
  },
  REMOVE_ALL_PORTFOLIOS_FROM_COMPARISON: (state) => {
    state.portfoliosToCompare.data = [];
  },
  GET_PORTFOLIO_COMPARISON_GRAPH_INFO_SUCCESS: (state, data) => {
    state.getPortfolioComparisonGraphInfo = data;
  },
  GET_PORTFOLIO_COMPARISON_GRAPH_INFO_ERROR: (state, error) => {
    state.getPortfolioComparisonGraphInfo.error = error;
  },

  CREATE_PORTFOLIO_INIT: (state) => {
    state.createPortfolio = { data: null, loading: true, error: null };
  },
  CREATE_PORTFOLIO_SUCCESS: (state, data) => {
    state.createPortfolio.data = data;
    state.createPortfolio.loading = false;
    state.getMyPortfolios.data.portfolios.push(data);
  },
  CREATE_PORTFOLIO_ERROR: (state, error) => {
    state.createPortfolio.error = error;
    state.createPortfolio.loading = false;
  },
  SET_GET_MY_PORTFOLIOS_LOADING: (state, loading) => {
    state.getMyPortfolios.loading = loading;
  },
  RESET_GET_PORTFOLIO_BY_ID: (state) => {
    state.getPortfolioById = { data: null, loading: null, error: null };
  },
  GET_PORTFOLIO_BY_ID_INIT: (state) => {
    state.getPortfolioById = { data: null, loading: true, error: null };
  },
  GET_PORTFOLIO_BY_ID_SUCCESS: (state, data) => {
    state.getPortfolioById = { data: data, loading: false, error: null };
  },
  GET_PORTFOLIO_BY_ID_ERROR: (state, error) => {
    state.getPortfolioById = { data: null, loading: false, error: error };
  },
  INCREMENT_PORTFOLIO_REPOST_COUNT: (state) => {
    state.getPortfolioById.data.socials.repostCount++;
  },
  UPDATE_PORTFOLIO_LINES: (state, data) => {
    const updatedPortfolio = state.getMyPortfolios?.data?.portfolios.find(
      (p) => p.id === data.id
    );
    if (updatedPortfolio) updatedPortfolio.lineCount = data.lineCount;
  },
  UPDATE_PORTFOLIO_NAME(state, newName) {
    if (state.getPortfolioById) {
      state.getPortfolioById.data.name = newName;
    }
  },
  UPDATE_PORTFOLIO_DESCRIPTION(state, newDesc) {
    if (state.getPortfolioById) {
      state.getPortfolioById.data.description = newDesc;
    }
  },
  TOGGLE_PORTFOLIO_RANK_NOTIFICATIONS: (state, data) => {
    const portfolio = state.getMyPortfolios?.data?.portfolios.find(
      (p) => p.id === data.portfolioId
    );

    if (!portfolio) return;

    portfolio.notifyOnLeagueRankChange = data.value;
  },
  TOGGLE_PORTFOLIO_RANK_NOTIFICATIONS_ERROR: (state, err) => {
    state.togglePortfolioRankNotifications.error = err;
  },
  VALIDATE_PORTFOLIO_OPERATION_INIT: (state) => {
    state.validatePortfolioOperation.data = null;
    state.validatePortfolioOperation.error = null;
    state.validatePortfolioOperation.loading = true;
  },
  VALIDATE_PORTFOLIO_OPERATION_SUCCESS: (state, data) => {
    state.validatePortfolioOperation.data = data;
  },
  VALIDATE_PORTFOLIO_OPERATION_ERROR: (state, error) => {
    state.validatePortfolioOperation.error = error;
  },
  SET_VALIDATE_PORTFOLIO_OPERATION_LOADING: (state, value) => {
    state.validatePortfolioOperation.loading = value;
  },
  SET_PORTFOLIO_ORDERS: (state, value) => {
    state.portfolioOrders.data = value;
  },
  SET_PORTFOLIO_ORDER_ERROR: (state, value) => {
    state.portfolioOrders.error = value;
  },
  SET_PORTFOLIO_ORDERS_LOADING: (state, value) => {
    state.portfolioOrders.loading = value;
  },
  CREATE_PORTFOLIO_ORDER_ERROR: (state, value) => {
    state.createPortfolioOrder.error = value;
  },
  CREATE_PORTFOLIO_ORDER_SUCCESS: (state, value) => {
    state.createPortfolioOrder.data = value;
  },
  CREATE_PORTFOLIO_ORDER_LOADING: (state, value) => {
    state.createPortfolioOrder.loading = value;
  },
  CANCEL_PORTFOLIO_ORDER_LOADING: (state, value) => {
    state.cancelPortfolioOrder.loading = value;
  },
  CANCEL_PORTFOLIO_ORDER_ERROR: (state, value) => {
    state.cancelPortfolioOrder.error = value;
  },
  CANCEL_PORTFOLIO_ORDER_SUCCESS: (state, value) => {
    // Replacing the order's relevant data with response
    const orderIndex = state.getPortfolioById?.data?.orders?.findIndex(
      (p) => p.portfolioOrderId === value.portfolioOrderId
    );

    if (orderIndex >= 0) {
      state.getPortfolioById.data.orders.splice(orderIndex, 1, value);
    }

    if (value.operationType !== 'Buy') return;

    // Update cash held for cash item
    const cashItem = state.getPortfolioById.data?.cashItems.find(
      (ci) => ci.currencyCode === value.operationCurrency
    );

    if (!cashItem) {
      throw new Error(
        `CANCEL_PORTFOLIO_ORDER_SUCCESS: no cash item found for currency ${value.operationCurrency}`
      );
    }

    if (
      value.buyCashAmountInPortfolioCurrency == null ||
      value.buyCashAmount == null
    ) {
      throw new Error(
        'CANCEL_PORTFOLIO_ORDER_SUCCESS: buyCashAmountInPortfolioCurrency and buyCashAmount are required for Buy orders'
      );
    }
    cashItem.pendingChargeInPortfolioCurrency -=
      value.buyCashAmountInPortfolioCurrency;
    cashItem.pendingCharge -= value.buyCashAmount;
  },
  APPEND_PORTFOLIO_ORDER: (state, value) => {
    if (state.getPortfolioById.data?.id !== value.portfolioId) return;

    state.getPortfolioById.data.orders.unshift(value);

    if (value.operationType !== 'Buy') return;

    // Updating cash held for cash item
    const cashItem = state.getPortfolioById.data?.cashItems.find(
      (ci) => ci.currencyCode === value.operationCurrency
    );

    if (!cashItem) {
      throw new Error(
        `APPEND_PORTFOLIO_ORDER: no cash item found for currency ${value.operationCurrency}`
      );
    }

    if (
      value.buyCashAmountInPortfolioCurrency == null ||
      value.buyCashAmount == null
    ) {
      throw new Error(
        'APPEND_PORTFOLIO_ORDER: buyCashAmountInPortfolioCurrency and buyCashAmount are required for Buy orders'
      );
    }
    cashItem.pendingChargeInPortfolioCurrency +=
      value.buyCashAmountInPortfolioCurrency;
    cashItem.pendingCharge += value.buyCashAmount;
  },

  ...MutationsCreator([
    {
      name: 'ORDER_PORTFOLIOS',
      state: 'orderPortfolios',
    },
    {
      name: 'GET_PORTFOLIO_GRAPH',
      state: 'getPortfolioGraph',
    },
    {
      name: 'GET_MY_PORTFOLIOS',
      state: 'getMyPortfolios',
    },
    {
      name: 'CREATE_OPERATION',
      state: 'createOperation',
    },
    {
      name: 'CREATE_CASH_OPERATION',
      state: 'createCashOperation',
    },
    {
      name: 'ADD_PORTFOLIO_ITEM',
      state: 'addPortfolioItem',
    },
  ]),
};
